// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"73":"stps-ocupaciones","565":"nine-box","884":"am"}[chunkId] || chunkId) + "." + {"73":"b0273f24","565":"75498f6b","629":"cd21e849","636":"e0b59052","884":"f72f32b1"}[chunkId] + ".css";
};